module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#f9fbff"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": _vm.y === 'top',
      "bottom": _vm.y === 'bottom',
      "right": _vm.x === 'right',
      "left": _vm.x === 'left',
      "multi-line": _vm.mode === 'multi-line',
      "vertical": _vm.mode === 'vertical'
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbarText) + "\n        "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "white"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    class: _vm.launchedFromClin ? 'clin' : '',
    attrs: {
      "permanent": "",
      "app": ""
    }
  }, [_c('br'), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    class: [_vm.component === 'OverviewPage' ? 'activeTab' : ''],
    on: {
      "click": function($event) {
        _vm.selectComponent('OverviewPage')
      }
    }
  }, [_c('v-list-tile-action', {
    class: [_vm.component === 'OverviewPage' ? 'margin_ActiveTab' : '']
  }, [(_vm.component === 'OverviewPage') ? _c('span', [_c('v-icon', {
    attrs: {
      "color": "primary darken-1"
    }
  }, [_vm._v("library_books")])], 1) : _c('span', {
    attrs: {
      "color": "blue-grey darken-2"
    }
  }, [_c('v-icon', [_vm._v("library_books")])], 1)]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    class: [_vm.component === 'OverviewPage' ? 'activeTabText' : '']
  }, [_vm._v("\n             Overview\n           ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    class: [_vm.component === 'GeneticTestingRegistry' ? 'activeTab' : ''],
    on: {
      "click": function($event) {
        _vm.selectComponent('GeneticTestingRegistry')
      }
    }
  }, [_c('v-list-tile-action', {
    class: [_vm.component === 'GeneticTestingRegistry' ? 'margin_ActiveTab' : '']
  }, [(_vm.component === 'GeneticTestingRegistry') ? _c('span', [_c('v-icon', {
    attrs: {
      "color": "primary darken-1"
    }
  }, [_vm._v("sort")])], 1) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "blue-grey darken-2"
    }
  }, [_vm._v("sort")])], 1)]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    class: [_vm.component === 'GeneticTestingRegistry' ? 'activeTabText' : '']
  }, [_vm._v("\n             Genetic Testing Registry\n             "), _c('v-badge', {
    staticClass: "badge-bg-color",
    attrs: {
      "color": "primary darken-1",
      "right": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.NumberOfGenesSelectedFromGTR))])])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    class: [_vm.component === 'Phenolyzer' ? 'activeTab' : ''],
    on: {
      "click": function($event) {
        _vm.selectComponent('Phenolyzer')
      }
    }
  }, [_c('v-list-tile-action', {
    class: [_vm.component === 'Phenolyzer' ? 'margin_ActiveTab' : '']
  }, [(_vm.component === 'Phenolyzer') ? _c('span', [_c('img', {
    attrs: {
      "src": require("../assets/images/phenolyzer2.svg"),
      "alt": "",
      "height": "28px",
      "width": "28px"
    }
  })]) : _c('span', [_c('img', {
    staticStyle: {
      "margin-left": "-4px"
    },
    attrs: {
      "src": require("../assets/images/phenolyzer1.svg"),
      "height": "28px",
      "width": "28px"
    }
  })])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    class: [_vm.component === 'Phenolyzer' ? 'activeTabText' : '']
  }, [_vm._v("\n             Phenolyzer\n             "), _c('v-badge', {
    staticClass: "badge-bg-color",
    attrs: {
      "color": "primary",
      "right": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.NumberOfGenesSelectedFromPhenolyzer))])])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    class: [_vm.component === 'AddGenes' ? 'activeTab' : ''],
    on: {
      "click": function($event) {
        _vm.selectComponent('AddGenes')
      }
    }
  }, [_c('v-list-tile-action', {
    class: [_vm.component === 'AddGenes' ? 'margin_ActiveTab' : '']
  }, [(_vm.component === 'AddGenes') ? _c('span', [_c('v-icon', {
    attrs: {
      "color": "primary darken-1"
    }
  }, [_vm._v("playlist_add")])], 1) : _c('span', [_c('v-icon', {
    attrs: {
      "color": "blue-grey darken-2"
    }
  }, [_vm._v("playlist_add")])], 1)]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    class: [_vm.component === 'AddGenes' ? 'activeTabText' : '']
  }, [_vm._v("\n             Add Genes\n             "), _c('v-badge', {
    staticClass: "badge-bg-color",
    attrs: {
      "color": "primary",
      "right": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.manuallyAddedGenes.length))])])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    class: [_vm.component === 'SummaryTab' ? 'activeTab' : ''],
    on: {
      "click": function($event) {
        _vm.selectComponent('SummaryTab')
      }
    }
  }, [_c('v-list-tile-action', {
    class: [_vm.component === 'SummaryTab' ? 'margin_ActiveTab' : '']
  }, [(_vm.component === 'SummaryTab') ? _c('span', [_c('v-icon', {
    staticStyle: {
      "transform": "rotate(90deg)"
    },
    attrs: {
      "color": "primary darken-1"
    }
  }, [_vm._v("merge_type")])], 1) : _c('span', [_c('v-icon', {
    staticStyle: {
      "transform": "rotate(90deg)"
    },
    attrs: {
      "color": "blue-grey darken-2"
    }
  }, [_vm._v("merge_type")])], 1)]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    class: [_vm.component === 'SummaryTab' ? 'activeTabText' : '']
  }, [_vm._v("\n             Summary\n             "), _c('v-badge', {
    staticClass: "badge-bg-color",
    attrs: {
      "color": "primary",
      "right": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.NumberOfAllGenes))])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('v-toolbar', {
    class: _vm.launchedFromClin ? 'clin' : '',
    attrs: {
      "dark": "",
      "height": _vm.launchedFromClin ? 45 : 64,
      "clipped-left": _vm.$vuetify.breakpoint.mdAndUp,
      "fixed": ""
    }
  }, [_c('v-toolbar-title', [_c('span', [_vm._v("panel.iobio")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "130px"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "bottom": "",
      "offset-y": ""
    }
  }, [_c('v-btn', {
    class: _vm.launchedFromClin ? 'clinButtonColor' : '',
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [(!_vm.launchedFromClin) ? _c('v-icon', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_vm._v("input")]) : _vm._e(), _vm._v("\n          Export\n        ")], 1), _vm._v(" "), _c('v-list', [(_vm.component === 'GeneticTestingRegistry') ? _c('div', [_c('v-list-tile', {
    on: {
      "click": _vm.copyGtrGenes
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("content_copy")]), _vm._v("   Copy GTR genes to clipboard")], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.exportGtrGenes
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("input")]), _vm._v("   Export GTR genes to file")], 1)], 1), _vm._v(" "), _c('hr')], 1) : (_vm.component === 'Phenolyzer') ? _c('div', [_c('v-list-tile', {
    on: {
      "click": _vm.copyPhenolyzerGenes
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("content_copy")]), _vm._v("   Copy Phenolyzer genes to clipboard")], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.exportPhenolyzerGenes
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("input")]), _vm._v("   Export Phenolyzer genes to file")], 1)], 1), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.copyAllGenes
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("content_copy")]), _vm._v("   Copy all genes to clipboard")], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.exportAllGenes
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("input")]), _vm._v("   Export all genes to file")], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.component === 'SummaryTab'),
      expression: "component==='SummaryTab'"
    }],
    on: {
      "click": _vm.exportGenesAsCSV
    }
  }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v("save")]), _vm._v("   Export genes as CSV")], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "350"
    },
    model: {
      value: (_vm.newAnalysisDialog),
      callback: function($$v) {
        _vm.newAnalysisDialog = $$v
      },
      expression: "newAnalysisDialog"
    }
  }, [_c('v-btn', {
    class: _vm.launchedFromClin ? 'clinButtonColor' : '',
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [(!_vm.launchedFromClin) ? _c('v-icon', [_vm._v("autorenew")]) : _vm._e(), _vm._v("Clear All")], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Are you sure you want to clear all?")]), _vm._v(" "), _c('v-card-text', [_vm._v("Clicking \"Yes\" will clear results from all pages and begin a new analysis.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.forceReload($event)
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.newAnalysisDialog = false
      }
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('HelpMenu', {
    attrs: {
      "launchedFromClin": _vm.launchedFromClin
    }
  }), _vm._v(" "), _c('AppsMenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.launchedFromClin),
      expression: "!launchedFromClin"
    }]
  })], 1), _vm._v(" "), _c('div', [_c('v-content', {
    class: _vm.launchedFromClin ? 'clin' : '',
    staticStyle: {
      "padding": "0px 0px 0px 300px"
    }
  }, [_c('div', {
    staticClass: "header-nav-bar"
  }, [_c('v-card-text', [_c('p')])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "white",
      "height": "auto"
    }
  }, [_c('keep-alive', [_c('Overview', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.component === 'OverviewPage'),
      expression: "component==='OverviewPage'"
    }]
  })], 1), _vm._v(" "), _c('keep-alive', [_c('GeneticTestingRegistry', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.component === 'GeneticTestingRegistry'),
      expression: "component==='GeneticTestingRegistry'"
    }],
    attrs: {
      "selectedVendorsListCB": _vm.selectedVendorsList,
      "selectedDisordersListCB": _vm.selectedDisordersList,
      "chartColor": _vm.ordinalColor,
      "barColor": _vm.barColor,
      "launchedFromClin": _vm.launchedFromClin,
      "browser": _vm.browser,
      "clinSearchedGtr": _vm.clinGtrSearchTerm,
      "clinFetchingGtr": _vm.clinFetchingGtr,
      "clinGenes": _vm.clinGenesGtr,
      "isMobile": _vm.isMobile
    },
    on: {
      "vendorListCB": function($event) {
        _vm.updateVendors($event)
      },
      "diseasesCB": function($event) {
        _vm.addDiseases($event)
      },
      "disorderNamesListCB": function($event) {
        _vm.updateDisorderNames($event)
      },
      "modeOfInheritanceData": function($event) {
        _vm.modeOfInheritanceData($event)
      },
      "GeneMembershipData": function($event) {
        _vm.GeneMembershipData($event)
      },
      "UpdateNumberOfGenesSelectedFromGTR": function($event) {
        _vm.updateGtrTabBadge($event)
      },
      "UpdateListOfSelectedGenesGTR": function($event) {
        _vm.updateGtrGenes($event)
      },
      "search-gtr": _vm.onSearchGTR
    }
  })], 1), _vm._v(" "), _c('keep-alive', [_c('Phenolyzer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.component === 'Phenolyzer'),
      expression: "component==='Phenolyzer'"
    }],
    attrs: {
      "launchedFromClin": _vm.launchedFromClin,
      "browser": _vm.browser,
      "isMobile": _vm.isMobile,
      "clinsearchedPhenolyzer": _vm.clinPhenolyzerSeachTerm,
      "clinGenes": _vm.clinGenesPhenolyzer,
      "SearchTheDisorderInPhenolyzer": _vm.SearchTheDisorderInPhenolyzer
    },
    on: {
      "NoOfGenesSelectedFromPhenolyzer": function($event) {
        _vm.updatePhenolyzerTabBadge($event)
      },
      "SelectedPhenolyzerGenesToCopy": function($event) {
        _vm.updatePhenolyzerGenes($event)
      },
      "search-phenotype": _vm.onSearchPhenotype,
      "phenotypeSearchTermArray": _vm.phenotypeSearchTermArray
    }
  })], 1), _vm._v(" "), _c('keep-alive', [_c('AddGenes', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.component === 'AddGenes'),
      expression: "component==='AddGenes'"
    }],
    attrs: {
      "launchedFromClin": _vm.launchedFromClin,
      "clinGenesManual": _vm.clinGenesManual
    },
    on: {
      "importedGenes": _vm.importedGenes
    }
  })], 1), _vm._v(" "), _c('keep-alive', [_c('SummaryTab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.component === 'SummaryTab'),
      expression: "component==='SummaryTab'"
    }],
    attrs: {
      "NumberOfGtrGenes": _vm.NumberOfGenesSelectedFromGTR,
      "NumberOfPhenolyzerGenes": _vm.NumberOfGenesSelectedFromPhenolyzer,
      "GtrGenesForSummary": _vm.selectedGtrGenes,
      "searchTermGTR": _vm.searchTermGTR,
      "PhenolyzerGenesForSummary": _vm.selectedPhenolyzerGenes,
      "onSearchPhenotype": _vm.phenotypeSearches,
      "manuallyAddedGenes": _vm.manuallyAddedGenes,
      "chartColor": _vm.ordinalColor,
      "browser": _vm.browser,
      "isMobile": _vm.isMobile
    }
  })], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac3e508e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/Main.vue
// module id = 517
// module chunks = 0